import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DataReportService } from '@app/_components/data-report/data-report.service';
import { PropertyService } from '@app/_components/property';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-vrbo-lodging-rate',
    templateUrl: './vrbo-lodging-rate.component.html',
    styleUrls: ['./vrbo-lodging-rate.component.css'],
    standalone: false
})
export class VRBOLodgingRateComponent implements OnInit {
  formLoading = false;

  rows: Array<{
    createDate: string;
    shortTermRentalId?: number;
    queueStatus?: string;
    testResultDesc?: string;
  }> = [];

  properties: Array<{ shortTermRentalId: number; propertyCode: string }> = [];
  selectedShortTermRentalId?: number;

  constructor(
    private messageService: MessageService,
    private dataReportService: DataReportService,
    private propertyService: PropertyService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  get filteredRows() {
    if (!this.selectedShortTermRentalId) {
      return this.rows;
    }
    return this.rows.filter(r => r.shortTermRentalId === this.selectedShortTermRentalId);
  }

  loadData(): void {
    this.formLoading = true;
    forkJoin([
      this.dataReportService.fetchVrboData('VrboLodgingRateSync'),
      this.propertyService.findAllSummary()
    ]).subscribe(
      ([reportRes, propRes]: any[]) => {
        const reports: any[] = reportRes?.data?.qualityTests || reportRes?.data?.dataReports || [];
        this.rows = reports.map(r => ({
          createDate: r?.createDate,
          shortTermRentalId: r?.shortTermRentalId != null && r?.shortTermRentalId !== '' ? Number(r.shortTermRentalId) : undefined,
          queueStatus: r?.queueStatus,
          testResultDesc: r?.testResultDesc
        }));

        const props: any[] = propRes?.data?.properties || [];
        this.properties = props.map(p => ({
          shortTermRentalId: p.shortTermRentalId,
          propertyCode: p.propertyCode
        }));
        this.formLoading = false;
      },
      (err: any) => {
        this.formLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.message || 'Failed to load lodging rate data' });
      }
    );
  }
}


